/**
 * 
 * @param {Date} priority_from 
 * @param {Date} priotity_to 
 * @param {Date} now_serv_time 
 * @param {boolean} community 
 */

function initStickyMenu(priority_from,priotity_to,now_serv_time,community) {
    var communitySubmenu = $('section.community-submenu-v2'),
        priority_from,
        priotity_to,
        now_serv_time,
        community;
    
    // This code is not working as expected, so we are commenting it out for now.
    // The Date is returning a NaN value, so we are not able to compare the dates.
    // Also note this is the same code on the server side that shows/hides the Priority List.
    
    //if(priority_from != null && priotity_to != null && now_serv_time != null && community != null ) {
        /*
        * Hide links in the subnav if the modules that the submenu link to do no exist on the page
        */
        // We do it on the client side to make sure output caching doesn't cause problem
    //    let priorityFrom = new Date(priority_from).getTime(),
    //        priorityTo = new Date(priotity_to).getTime(),
    //        nowSrvTime = new Date(now_serv_time).getTime(),
    //        isCommunity = community;

        

    //    $('#priorityLink').hide();
    //    if (isCommunity && nowSrvTime > priorityFrom && nowSrvTime < priorityTo)
    //    {
    //        $('#priorityLink').show();
    //    }
    //}

    if(communitySubmenu) {

        $("section.community-submenu-v2 ol.community-desktop-sticky_menu li a, section.community-submenu-v2 li.community-mobile-sticky_menu-item a").each(function () {
            var link = $(this);
            var href = link.attr("href");

            if ($(link.attr("href")).length == 0) {
                $(this).parent().remove();
            }

            // If we got this far, we know we have an HREF...try to grab the element it references
            var elem = $(href);
            if (elem.length === 0 || elem.is(":visible") === false) {
                // Hide links if the element they reference doesnt exist on the page
                $(this).parent().remove();
            }
        });


        $(window).bind("load", function () {
            if (window.location.href.indexOf("#community-facts") > -1) {
                setTimeout(function () {
                    $('.community-desktop-sticky_menu-link').each(function () {
                        $(this).removeClass("is-active");
                    });
                }, 1000);

            }
            //Removes the is-loading class once JS is done to not interfere with sticky-nav behaviour
            $('.community-submenu-v2').removeClass('is-loading');
        });
    }
}

window.initStickyMenu = initStickyMenu;

/**
 * 
 * @param {HTMLElement} stickyMenuElem 
 */
function initStickyMenuGeneral(stickyMenuElem) {
    if(stickyMenuElem) {

        // Retrieve the desktop and mobile links
        stickyMenuElem.querySelectorAll(".general-sticky_menu a, .general-mobile-sticky_menu-item a").forEach((elem) => {
            var link = elem;
            var linkHref = link.getAttribute("href");

            // Check if this current link has an empty HREF and remove it if it does
           
            if (linkHref === null || linkHref.length == 0) {
                link.parentNode.parentNode.removeChild(link.parentNode);
            }

            // If we got this far, we know we have an HREF...try to grab the element it references
            var elem = document.querySelector(linkHref);
            if (elem == null || elem.length === 0) {
                // Hide links if the element they reference doesnt exist on the page
                link.parentNode.parentNode.removeChild(link.parentNode);
            }
        });
    }
}
window.initStickyMenuGeneral = initStickyMenuGeneral;